import { Outlet, useMatches, useNavigate } from 'react-router'

import { NotFound } from 'features/not-found'
import { useFeatureFlags } from 'features/project'
import { useProjectStore } from 'features/project/store'
import { checkRouteAccess } from 'routes/access'
import { ProjectState } from 'types/project'

type RouteHandle = { featureKey?: string }

export const FeatureGuardLayout: React.FC = () => {
  const navigate = useNavigate()
  const { data: featureFlags } = useFeatureFlags()
  const details = useProjectStore((state: ProjectState) => state.details)
  const projectId = useProjectStore((state: ProjectState) => state.projectId)
  const pageSettings = details?.clientSettings?.project?.pages

  const matches = useMatches()
  const currentMatch = matches[matches.length - 1]
  const featureKey = (currentMatch?.handle as RouteHandle)?.featureKey

  if (!featureFlags || !pageSettings) return null

  if (
    featureKey &&
    !checkRouteAccess(
      featureKey,
      featureFlags as Record<string, boolean>,
      pageSettings,
      projectId,
    )
  ) {
    return (
      <NotFound
        onBackToHome={() => navigate(projectId ? `/project/${projectId}` : '/')}
      />
    )
  }

  return <Outlet />
}
